<script lang="ts">
	import tooltip from '$lib/tooltip/tooltip';
	export let title: string = '';
	export let header: string = '';
	export let tooltipTemplate: string | Element = '';
	export let addInfoIcon: boolean = false;
</script>

<div class="cursor-pointer h-full">
	<div
		use:tooltip={{ header, title, tooltipTemplate }}
		data-template="tooltip-id"
		class="flex gap-1 items-center justify-center h-full"
	>
		<slot />
		{#if addInfoIcon}
			<div class="w-4 h-4">
				<img src="info_grey.png" alt="" />
			</div>
		{/if}
	</div>
</div>
